// Generates the resulting object based on the tree
export const fromRoot = (root, value, result = {}) => {
  result[root.key] = value;
  for (const child of root.sub) {
    fromRoot(child, child.op.run(value), result);
  }
  return result;
};

// like "undefined", just that it can be distinguished from "undefined" as an operation might return that
//const nothing = Symbol('nothing');
const nothing = "nothing";

// Calculates the base value from one of the trees nodes
export const getBase = (tree, key, value) => {
  if (tree.key === key) return tree.op.invert().run(value);

  for (const child of tree.sub) {
    const res = getBase(child, key, value);
    if (res === nothing) continue;
    return tree.op.invert().run(res);
  }

  return nothing;
};
